import { render, staticRenderFns } from "./IconArrowTriangle.vue?vue&type=template&id=68d7e1e2&scoped=true&"
import script from "./IconArrowTriangle.vue?vue&type=script&lang=js&"
export * from "./IconArrowTriangle.vue?vue&type=script&lang=js&"
import style0 from "./IconArrowTriangle.vue?vue&type=style&index=0&id=68d7e1e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7e1e2",
  null
  
)

export default component.exports